module.exports = __webpack_public_path__ + "static/media/13.d1b15036.jpg";